import { render, staticRenderFns } from "./PainelOndeEstouView.vue?vue&type=template&id=5137d86c&scoped=true&"
import script from "./PainelOndeEstouView.vue?vue&type=script&lang=ts&"
export * from "./PainelOndeEstouView.vue?vue&type=script&lang=ts&"
import style0 from "./PainelOndeEstouView.vue?vue&type=style&index=0&id=5137d86c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137d86c",
  null
  
)

export default component.exports